﻿import { ProjectMilestoneStatusActions } from "@/enums";

export const milestoneWillCompleteProject = (
  action,
  shouldCompleteProject,
  finalApprover
) =>
  shouldCompleteProject &&
  (action === ProjectMilestoneStatusActions.Release ||
    (action === ProjectMilestoneStatusActions.Approve && finalApprover));
